(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const splitSingleLineProductTitles = (container = document) => {
    const titleElements = container.querySelectorAll('.product-card a.contents.user-select-text .text-block > *');

    titleElements.forEach((element) => {
      const originalText = element.dataset.originalTitleText || element.textContent.trim();

      if (!originalText || !originalText.includes(' ')) return;

      if (!element.dataset.originalTitleText) {
        element.dataset.originalTitleText = originalText;
      }

      element.innerHTML = originalText;

      const computedStyle = window.getComputedStyle(element);
      let lineHeight = parseFloat(computedStyle.lineHeight);

      if (Number.isNaN(lineHeight)) {
        const fontSize = parseFloat(computedStyle.fontSize);
        lineHeight = fontSize * 1.2;
      }

      const isSingleLine = element.getBoundingClientRect().height <= lineHeight * 1.5;

      if (!isSingleLine) return;

      const words = originalText.split(/\s+/);
      if (words.length < 2) return;

      let splitIndex = 1;
      const midpoint = originalText.length / 2;
      let bestDistance = Infinity;
      let currentLength = 0;

      words.slice(0, -1).forEach((word, index) => {
        currentLength += word.length;
        const distance = Math.abs(midpoint - currentLength);

        if (distance < bestDistance) {
          bestDistance = distance;
          splitIndex = index + 1;
        }

        currentLength += 1;
      });

      const firstLine = words.slice(0, splitIndex).join(' ');
      const secondLine = words.slice(splitIndex).join(' ');

      if (!firstLine || !secondLine) return;

      element.innerHTML = `${firstLine}<br>${secondLine}`;
    });
  };

  const initSplitSingleLineProductTitles = () => {
    const resultsList = document.querySelector('results-list[section-id="{{ section.id }}"]');
    if (!resultsList) return;

    splitSingleLineProductTitles(resultsList);

    const observer = new MutationObserver(() => {
      splitSingleLineProductTitles(resultsList);
    });

    observer.observe(resultsList, { childList: true, subtree: true });

    window.addEventListener('resize', () => {
      splitSingleLineProductTitles(resultsList);
    });
  };

  document.addEventListener('DOMContentLoaded', initSplitSingleLineProductTitles, { once: true });

  } catch(e) { console.error(e); }
})();
})();
